<!-- components/Footer.vue -->
<template>
  <footer>
    <div>
      <div class="wow animate__fadeInLeft">
        <div class="logo">
          <img src="@/assets/header-logo.png" width="100%" alt="" />
        </div>
        <div>
          <div>
            <div>
              <a href="mailto:Hello@mydigim.com?subject=Hello&body=This is a email."><img style="cursor: pointer;"
                  src="@/assets/footer/icon5.png" /></a>
              <span>Hello@mydigim.com</span>
            </div>
            <div><img src="@/assets/footer/logo1.png" /><img src="@/assets/footer/logo2.png" /></div>
          </div>
          <!-- <div>
              India: +91 7262900719<br/>
              Dubai: +971 4409 8888<br/>
              London: +44 20 7730 1234
            </div> -->
        </div>
      </div>

      <div class="wow animate__fadeInRight">
        <div>
          <h5>Experience</h5>
          <ul>
            <li @click="goTo('flooterOne')">Project Management</li>
            <li @click="goTo('flooterTwo')">Events</li>
            <li @click="goTo('flooterThree')">Technology</li>
            <li @click="goTo('flooterFour')">Gaming</li>
            <li @click="goTo('indiaLegends')">Film and Television</li>
          </ul>
        </div>
        <div>
          <h5>Services</h5>
          <ul>
            <li @click="goTo('AppServices')">Design</li>
            <li @click="goTo('AppServices')">Social Media</li>
            <li @click="goTo('AppServices')">Digital Marketing</li>
            <li @click="goTo('AppServices')">Content</li>
            <li @click="goTo('AppServices')">Project Management</li>
          </ul>
        </div>
        <div>
          <h5>Work</h5>
          <ul>
            <li @click="goTo('AppAbout')">About</li>
            <li @click="goTo('AppContact')">Contact</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="wow animate__slideInUp">Copyright @ MYD, LLP&thinsp;. All rights reserved</div>
  </footer>
</template>

<script setup>
import { useRouter } from 'vue-router';

const router = useRouter();

const goTo = (name) => {
  router.push({ name });
};
</script>

<style lang="less" scoped>
footer {
  display: flex;
  flex-direction: column;
  padding: 10px 20px;
  background-color: #fff;
  color: #172d43;
  margin: 0px 5%;
  overflow: hidden;

  >div:nth-child(1) {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    flex: 1;
    width: 100%;

    >div:nth-child(1) {
      flex: 1;
      min-width: 300px;

      >div:nth-child(2) {
        display: flex;
        flex-direction: row;
        text-align: left;
        gap: 2%;

        >div:nth-child(1) {
          >div:nth-child(1) {
            display: flex;
            gap: 15px;
            align-items: center;
            margin-bottom: 10px;
            margin-top: 10px;

            img {
              width: 30px;
              vertical-align: middle;
            }
          }
        }

        >div:nth-child(2) {
          line-height: 2;
          font-weight: 300;
          font-size: 1.2vw;
        }
      }
    }

    >div:nth-child(2) {
      flex: 1;
      display: flex;
      gap: 6%;
      text-align: left;
      line-height: 2;
      min-width: 300px;
      justify-content: space-between;

      h5 {
        margin: 10px auto;
        font-weight: 500 !important;
        font-size: max(1.9vw, 16px);
        font-weight: bold;
      }

      ul {
        list-style: none;
        margin: 0px !important;
        padding: 0px !important;
        font-size: max(1.2vw, 12px);

        li {
          cursor: pointer;
          list-style-type: none;
        }
      }
    }

    .logo {
      width: 8vw;
      min-width: 80px;
      text-align: left;
    }
  }

  >div:nth-child(2) {
    flex: 1;
    text-align: left;
    font-size: max(1.2vw, 12px);
    margin-top: 2%;
  }

}

.nav-item {
  cursor: pointer;
}

@media all and (max-width:600px) {
  footer {
    padding: 10px 0px;
    margin: 0% 2%;

    >div:nth-child(1) {

      >div:nth-child(1) {
        flex: 1;
        min-width: 300px;
        margin-top: 8px;
        >div:nth-child(2) {
          display: flex;
          flex-direction: row;
          text-align: left;
          gap: 2%;

          >div:nth-child(1) {
            >div:nth-child(1) {
              display: flex;
              gap: 15px;
              align-items: center;
              margin-bottom: 15px;
              margin-top: 10px;

              img {
                width: 30px;
                vertical-align: middle;
              }
            }
          }
        }
      }
    }
  }
}
</style>